'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgRefresh } from '@common/icon';
import { cn } from '@core/utils';
import { motion } from 'framer-motion';
import { useSmoothStreamingText } from '../../_hooks/useSmoothStreamingText';
import type { ChatMessageData } from '../../_utils/message';
import styles from './AiMessage.module.scss';
import { CopyButton } from './CopyButton';
import { MarkdownContent } from './MarkdownContent';
const AI_TYPO_CLASS = 'typo-body3 mobile-tablet:typo-body4';
const stripIncompleteMarkdownBold = (text: string) => {
  let output = '';
  let cursor = 0;
  while (cursor < text.length) {
    const openIndex = text.indexOf('**', cursor);
    if (openIndex === -1) {
      output += text.slice(cursor);
      break;
    }
    output += text.slice(cursor, openIndex);
    const closeIndex = text.indexOf('**', openIndex + 2);
    if (closeIndex === -1) {
      output += text.slice(openIndex + 2);
      break;
    }
    output += text.slice(openIndex, closeIndex + 2);
    cursor = closeIndex + 2;
  }
  return output.endsWith('*') && !output.endsWith('**') ? output.slice(0, -1) : output;
};
interface AiMessageProps {
  message: ChatMessageData;
  isLatest?: boolean;
  onSelectOption?: (value: string) => void;
}
export const AiMessage = t0 => {
  const $ = _c(27);
  const {
    message,
    isLatest,
    onSelectOption
  } = t0;
  const rawText = message.content ?? "";
  const smoothedText = useSmoothStreamingText(rawText, !!message.isStreaming);
  let t1;
  if ($[0] !== message.isMarkdown || $[1] !== message.isStreaming || $[2] !== smoothedText) {
    t1 = message.isMarkdown && message.isStreaming ? stripIncompleteMarkdownBold(smoothedText) : smoothedText;
    $[0] = message.isMarkdown;
    $[1] = message.isStreaming;
    $[2] = smoothedText;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const renderText = t1;
  const isDone = !message.isStreaming;
  let t2;
  if ($[4] !== message.isMarkdown || $[5] !== message.isStreaming || $[6] !== message.textCenter || $[7] !== renderText) {
    t2 = renderText && (message.isMarkdown ? <MarkdownContent className={cn(AI_TYPO_CLASS, "whitespace-pre-wrap break-words font-500 text-Gray-900", message.textCenter && "text-center", message.isStreaming && styles.streamingCaret)}>{renderText}</MarkdownContent> : <p className={cn(AI_TYPO_CLASS, "whitespace-pre-line break-words font-500 text-Gray-900", message.textCenter && "text-center")}>{renderText}</p>);
    $[4] = message.isMarkdown;
    $[5] = message.isStreaming;
    $[6] = message.textCenter;
    $[7] = renderText;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== isDone || $[10] !== message.errorText) {
    t3 = isDone && message.errorText && <p className={cn(AI_TYPO_CLASS, "whitespace-pre-line break-keep font-500 text-R-500")}>{message.errorText}</p>;
    $[9] = isDone;
    $[10] = message.errorText;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== isDone || $[13] !== message.isCopy || $[14] !== rawText) {
    t4 = isDone && message.isCopy && <CopyButton text={rawText} />;
    $[12] = isDone;
    $[13] = message.isCopy;
    $[14] = rawText;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== isDone || $[17] !== isLatest || $[18] !== message.id || $[19] !== message.options || $[20] !== onSelectOption) {
    t5 = isLatest && isDone && message.options && onSelectOption && <div className="mt-4 flex w-full flex-row flex-wrap items-center gap-x-6 gap-y-10">{message.options.map((option, index) => <motion.div key={`${message.id}-option-${option.value}`} animate={{
        opacity: 1
      }} initial={{
        opacity: 0
      }} transition={{
        delay: 0.05 * index
      }}><button className={cn("flex h-40 items-center gap-6 rounded-pill border border-Gray-200 bg-Gray-white px-14 font-600 text-Gray-900 shadow-sm transition-colors typo-body4 hover:border-Gray-300 hover:bg-Gray-100", option.className)} type="button" onClick={() => onSelectOption(option.value)}>{option.value.startsWith("retry") && <SvgRefresh className="size-14 shrink-0 text-Gray-700" />}{option.label}</button></motion.div>)}</div>;
    $[16] = isDone;
    $[17] = isLatest;
    $[18] = message.id;
    $[19] = message.options;
    $[20] = onSelectOption;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5) {
    t6 = <div className="flex w-full flex-col gap-8"><div className="flex w-full flex-col gap-24 break-keep">{t2}{t3}{t4}{t5}</div></div>;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
};